// quizThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL, {
  SCHOOL_QUIZ_API_BASE_URL,
  getAgeGrps,
  getCount,
} from "../../components/config";
// export const createQuiz = createAsyncThunk(
//   "quiz/createQuiz",
//   async ({ formData, userId }, { rejectWithValue }) => {
//     try {
//       const body = {
//         title: formData.title,
//         start_date: formData.start,
//         total_questions: formData.totalQuestions,
//         duration_per_question: formData.questionDuration,
//         allotments: formData.allotments,
//         registration_start_date: formData.registrationStart,
//         registration_end_date: formData.registrationEnd,
//         marks_per_question: Number(formData.correct),
//         negative_marks_wrong: Number(formData.wrong),
//         negative_marks_skipped: Number(formData.skipped),
//         registration_fee: parseFloat(formData.registrationCost).toFixed(2),
//         prizes: formData.winnerPrizes.reduce((acc, val, idx) => {
//           acc[(idx + 1).toString()] = parseFloat(val || 0).toFixed(2);
//           return acc;
//         }, {}),
//         registration_type: formData.registrationFeeMode,
//         about_quiz: formData.about,
//         quiz_terms: formData.terms,
//         created_by: userId,
//       };

//       const res = await axios.post("/admin/create-quiz", body);
//       return res.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );
export const createQuiz = createAsyncThunk(
  "quiz/createQuiz",
  async (body, { rejectWithValue }) => {
    console.log(body.quiz_type);

    try {
      let res;
      if (body.quiz_type === 1 || body.quiz_type === 2) {
        res = await axios.post(
          `${SCHOOL_QUIZ_API_BASE_URL}/create-academic-quiz`,
          body
        );
      } else if (body.quiz_type === 3 || body.quiz_type === 4) {
        res = await axios.post(
          `${SCHOOL_QUIZ_API_BASE_URL}/create-theme-quiz`,
          body
        );
      } else {
        // res = await axios.post(
        //   `${SCHOOL_QUIZ_API_BASE_URL}/create-theme-quiz`,
        //   body
        // );
      }

      return res.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getUsersList = createAsyncThunk(
  "quiz/getUsersList",
  async (_, { rejectWithValue }) => {
    try {
      // const res = await axios.get(`${API_BASE_URL}/users`);
      const res = await axios.get(
       ` https://web1024.docmaster.in:5007/api/school/quiz/admin/student-users`
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const imageUpload = createAsyncThunk(
  "quiz/imageUpload",
  async ({ image, id, quiz_type }, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${API_BASE_URL}/quizzes`);
      const formData = new FormData();
      formData.append("image", image);
      formData.append("quiz_type", quiz_type);
      const res = await axios.put(
        `${SCHOOL_QUIZ_API_BASE_URL}/quiz/${id}`,
        formData
      ); // ✅ awai
      console.log(res);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getQuizzes = createAsyncThunk(
  "quiz/getQuizzes",
  async (quizType, { rejectWithValue }) => {
    try {
      const url = `${SCHOOL_QUIZ_API_BASE_URL}/quizzes?type=${quizType}`; // default
      const res = await axios.get(url);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateQuiz = createAsyncThunk(
  "quiz/updateQuiz",
  async (body, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/quizzes`);
      const res = await axios.put(
        `${SCHOOL_QUIZ_API_BASE_URL}/update-quiz`,
        body
      ); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const deleteQuiz = createAsyncThunk(
  "quiz/deleteQuiz",
  async ({ quiz_id, updated_by, quizType }, { rejectWithValue }) => {
    try {
      // const body = { quiz_id, updated_by };
      // const res = axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/quizzes`);
      const res = await axios.delete(
        `${SCHOOL_QUIZ_API_BASE_URL}/delete-quiz/${quiz_id}`,
        {
          data: { quiz_id, updated_by, quizType }, // 👈 body must be inside data
        }
      ); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const publishOrUnpublish = createAsyncThunk(
  "quiz/publishOrUnpublish",
  async ({ id, quizType }, { rejectWithValue }) => {
    try {
      // const res = axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/quizzes`);
      const res = await axios.post(
        `${SCHOOL_QUIZ_API_BASE_URL}/status-change?quiz_id=${id}&&quiz_type=${quizType}`
      ); // ✅ awai
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getRegisteredQuizUsersList = createAsyncThunk(
  "quiz/getRegisteredQuizUsersList",
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${SCHOOL_QUIZ_API_BASE_URL}/participants/${id}`
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 4 SEPT
export const getQuizParticipants = createAsyncThunk(
  "quiz/getQuizParticipants",
  async ({ quiz_id, limit = 10, offset }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${SCHOOL_QUIZ_API_BASE_URL}/live-quiz-participants?quiz_id=${quiz_id}&limit=${limit}&offset=${offset}`
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getQuizStudents = createAsyncThunk(
  "quiz/getQuizStudents",
  async ({ quiz_id, limit = 10, offset }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
         `${SCHOOL_QUIZ_API_BASE_URL}/live-quiz-participants?quiz_id=${quiz_id}&limit=${limit}&offset=${offset}`
        // `http://localhost:5007/api/school/quiz/admin/live-quiz-students?quiz_id=${quiz_id}&limit=${limit}&offset=${offset}`
      );
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getQuizParticipantsOld = createAsyncThunk(
  "quiz/getQuizParticipantsOld",
  async ({ quiz_id ,quiz_type}, { rejectWithValue },payload) => {
    try {
      console.log("CALLING LIVE API WITH:", payload);
      const res = await axios.get(
        `${SCHOOL_QUIZ_API_BASE_URL}/quiz-participants-details/${quiz_id}/${quiz_type}`
      );
      console.log("LIVE API RESPONSE:", res.data);
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getAgeGroups = createAsyncThunk(
  "quiz/getAgeGroups",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${getAgeGrps}`);
      return res.data;
    } catch (err) {
      console.log(err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getAvailableQuestionsCount = createAsyncThunk(
  "quiz/getAvailableQuestionsCount",
  async ({ class_id, subject_id }, { rejectWithValue }) => {
    try {
      // ✅ Only send class_id and subject_id in the request body
      const res = await axios.post(getCount, {
        class_id,
        subject_id,
      });
      console.log(res.data);
      return res.data;
    } catch (err) {
      console.error("❌ getAvailableQuestionsCount error:", err);
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
